import 'izitoast/dist/css/iziToast.min.css';
import './style/index.less';

import App from './app';

export default App;
